import C from '@/store/constants'

const VB_SERVICE_NAME = C.service.VB_SERVICE

export default {
  namespaced: true,

  actions: {

    energideklaration ({ dispatch }, { location, address, number}) {
      return new Promise(function(resolve, reject) {
        dispatch("API", VB_SERVICE_NAME, { root: true })
          .then((api) => api.get(`/boverket/energideklarationer?kommun=${encodeURIComponent(location)}&fastighetsbeteckning=${encodeURIComponent(number)}&address=${encodeURIComponent(address?.value)}`))
          .then((response) => resolve(response.data))
          .catch((err) => reject(err));
      })
    },
  }
}
